// Shared layout constants for the chatbot launcher (the floating Fab in
// App.js) and the panel that opens above it (ScrollDialog.js). These used to
// be duplicated across the two files with values that looked unrelated; keep
// them here so the launcher and the panel stay in sync and the relationship
// between them is explicit.

// Stacking context for both the launcher and the panel. Matches MUI's default
// modal/drawer range so the chatbot sits above page content but plays nicely
// with MUI overlays.
export const CHATBOT_Z_INDEX = 1300;

// Launcher (Fab) offset from the bottom-right corner of the viewport.
export const LAUNCHER_BOTTOM = 27;
export const LAUNCHER_RIGHT = 27;

// Panel offset from the same corner. The panel sits above the launcher, so its
// bottom offset clears the Fab (≈56px tall) plus a small gap above the
// launcher's own offset.
export const PANEL_BOTTOM = 90;
export const PANEL_RIGHT = 20;

// Gap kept between the panel and the opposite viewport edge, so the panel can
// never grow past the screen on small resolutions.
export const VIEWPORT_MARGIN = 20;
